import { IAppState } from '../../../../../redux';
import { selectActiveService } from '../../../../../selectors/publishTerms';

export const isShow = (state: IAppState): boolean => {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  const {
    publishOptions: { packageIds, periodIds },
  } = selectedService;

  return packageIds.length > 0 && periodIds.length > 0;
};
